export { EntityResolver, buildIdentityString, RESOLUTION_DEFAULTS } from './EntityResolver.js';
export type { ResolverMemoryHooks } from './EntityResolver.js';
export { normalizeSurface } from './fuzzy.js';
